// extracted by mini-css-extract-plugin
export default {"cardBoxSty":"SwitchRecord_cardBoxSty__uoHbM","tableHeader":"SwitchRecord_tableHeader__J-o56","tableRow":"SwitchRecord_tableRow__B4vTn","tableBody":"SwitchRecord_tableBody__Thxa-"};